module.exports = __webpack_public_path__ + "sunsemweb/img/join.25ebefd6.png";